/**
 * init_nomiResult
 */


document.addEventListener('DOMContentLoaded', function() {

	var isStorage = !!sessionStorage;
	if(isStorage) {

		var isStr = StorageOperator.isNotStorageData('session', 'state' );
		if( isStr ) {

			var state = StorageOperator.getStorageData('session', 'state');

			var poolObj = {};

			if(state.poolCateg) {
				var categ = state.poolCateg;
				if(categ==='Normal') {
					poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
				}else {
					poolObj.array = state.or34===3 ? allDataObj.highPool3: allDataObj.highPool4;
				};
			}else {
				poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
			};

			init(poolObj);
		}else {

			var isStrLo = StorageOperator.isNotStorageData('local', 'state');
			var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
			var boo = setState(or34);

			var poolObj = {};
			poolObj.array = allDataObj.pool3;

			init(poolObj)
		};

	}else {
		alert('お使いのブラウザでは、本サイトは正常に動作しません');
	};

}, false);



var nomiResultView;

function init(poolObj) {

	document.getElementById('ifra-result').src = './NumbResultNC.html';

	document.getElementById('modHelpBt').addEventListener( 'click', modHelpBtAction(false), false);
	let textArray = [ '説明 ON', '説明 OFF' ];
	MyUtility.setElementEvent('modHelpBt', 'click', MyUtility.buttonTextChenge( 'modHelpBt', textArray, false), false);
	

	if ("ontouchstart" in window) {
		MyUtility.setElementEvent('navData-down', 'click', MyUtility.buttonDownProcess( 'nav-pull-ul', false), false);
		MyUtility.setElementEvent('navData-down-2', 'click', MyUtility.buttonDownProcess( 'nav-pull-ul-2', false), false);
	}else {

		MyUtility.focusDownProcess( 'navData-down-li', 'nav-pull-ul' );
		MyUtility.focusDownProcess( 'navData-down-li-2', 'nav-pull-ul-2' );
	};
	

	let objList = [ { idString: 'cont-pull-ul-1', is: false }, { idString: 'cont-pull-ul-2', is: false },
					{ idString: 'cont-pull-ul-3', is: false }, { idString: 'cont-pull-ul-4', is: false }  ];
	MyUtility.setElementEvent('cont-label-down-1', 'click', MyUtility.buttonDownBoxProcess( objList, 0), false);
	MyUtility.setElementEvent('cont-label-down-2', 'click', MyUtility.buttonDownBoxProcess( objList, 1), false);
	MyUtility.setElementEvent('cont-label-down-3', 'click', MyUtility.buttonDownBoxProcess( objList, 2), false);
	MyUtility.setElementEvent('cont-label-down-4', 'click', MyUtility.buttonDownBoxProcess( objList, 3), false);
	// コンテンツボタン  モバイル用
	for(var i=0; i<4; i++) {
		if(document.getElementById('cont-pull-ul-'+(i+1)+'-mov')) {
			MyUtility.setElementStyle('cont-pull-ul-'+(i+1)+'-mov', 'display', 'none');
		};
	};
	let objList_mov = [ { idString: 'cont-pull-ul-1-mov', is: false }, { idString: 'cont-pull-ul-2-mov', is: false },
						{ idString: 'cont-pull-ul-3-mov', is: false }, { idString: 'cont-pull-ul-4-mov', is: false } ];
	for(var i=0; i<4; i++) {
		if(document.getElementById('cont-label-down-'+(i+1)+'-mov')) {
			MyUtility.setElementEvent('cont-label-down-'+(i+1)+'-mov', 'click', MyUtility.buttonDownBoxProcess( objList_mov, i), false);
		};
	};

	MyUtility.setElementEvent('yosou-h', 'click', MyUtility.buttonDownProcess( 'yosou-p', false), false);
	MyUtility.setElementEvent('zann-h', 'click', MyUtility.buttonDownProcess( 'zann-p', false), false);
	MyUtility.setElementEvent('check-h', 'click', MyUtility.buttonDownProcess( 'check-p', false), false);
	MyUtility.setElementEvent('kaisuu-h', 'click', MyUtility.buttonDownProcess( 'kaisuu-p', false), false);

	nomiResultView = new NomiResultView(poolObj);

	//  topSub
	document.getElementById('topSub-div').addEventListener('mouseenter', function() { return topSubFocus( topSubFocusSub )}, false);

};


/*
function initSecond() {
	initCount++;
	if(initCount===3) {

		setNb34State();
		init();
	};
};

var initCount = 0;

var dataObj = {};

function initFirst( namae, dataObj ) {
	init( dataObj );
};

function initSecond(name, obj) {
	initCount++;

	if(name==='nb_pool') {  dataObj = obj;  };
	if(initCount===2) {
		init( dataObj );
	};
};
*/


function topSubFocus(sub) {
	let timer = window.setTimeout(function() {
		document.getElementById("topSub-inn-div").style['display'] = 'none';
		document.getElementById("soukannzu-div").style['display'] = 'block';
	},300);
	document.getElementById('topSub-div').removeEventListener('mouseleave',() => sub(), false);
	document.getElementById('topSub-div').addEventListener('mouseleave',() => sub(timer), false);
};
function topSubFocusSub(timer) {
	if(timer) {   window.clearTimeout(timer);  };
	document.getElementById("topSub-inn-div").style['display'] = 'block';
	document.getElementById("soukannzu-div").style['display'] = 'none';
};



function setNb34State() {

	var isStrLo = StorageOperator.isNotStorageData('local', 'state');
	var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
	var boo = setState(or34);
};




function setState(val) {

	var stateObj = StorageOperator.makePageStateJson( val );

	stateObj.coeffValue = COEFF_ARRAY[ COEFF_INDEX ];

	var boo = [false, false];
	try {
		boo = StorageOperator.setStorageData( 'session', 'state', stateObj );		
	}catch(exeption) {
		//alert('お使いのブラウザでは、本サイトは正常に動作しません');
	};
	return boo[0];
};




// innerHelp表示有無  クロージャ
function modHelpBtAction(boo) {
	var state = boo;
	return function() {
		if(state) {
			document.getElementById('mainMobHelpInn').style['display'] = 'none';
			state = false;
		}else {
			document.getElementById('mainMobHelpInn').style['display'] = 'block';
			state = true;
		};
	};
};


// nav-data 表示有無  クロージャ
function navPullDown(boo) {
	var state = boo;
	return function() {

		if(state) {
			document.getElementById('nav-pull-ul').style['display'] = 'none';
			state = false;
		}else {
			document.getElementById('nav-pull-ul').style['display'] = 'block';
			state = true;
		};
	};
};

function setState34(val) {

	var isStorage = !!sessionStorage;

	if(isStorage) {

		var statelocalObj = StorageOperator.getStorageData('local', 'state');
    	if(statelocalObj) {
			statelocalObj.or34 = val;
		}else {
			statelocalObj = { or34: val };
		};

		var stateObj = StorageOperator.makePageStateJson( val );

		var boo = [false, false], boo2 = [false, false];
		try {
			boo = StorageOperator.setStorageData( 'session', 'state', stateObj );
			boo2 = StorageOperator.setStorageData( 'local', 'state', stateObj );
			
		}catch(exeption) {
			//alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
		//var isStr = StorageOperator.isNotStorageData('session', 'nb_result', 'nb_pool3', 'nb_pool4');

		//if( ! isStr ) {   alert('データ取得中です');   boo[0] = false;   };

		return boo[0] && boo2[0];
	};
	return false;
};

